export default function SvgGameFilters() {
  return (
    <svg
      width="0"
      height="0"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: 'absolute', width: 0, height: 0 }}
    >
      <defs>
        <clipPath
          id="boardImgClip"
          x="0"
          y="0"
          width="100%"
          height="100%"
          // width="871"
          // height="944"
          // clipPathUnits="userSpaceOnUse"
          clipPathUnits="objectBoundingBox"
        >
          <path
            style={{
              transform: 'scaleX(0.001148105626) scaleY(0.001059322034)',
            }}
            d="M866.4,58.3c-13.9-1.1-27-7.1-36.9-17c-9.9-9.9-16-22.9-17.1-36.8L812,0H58.7l-0.4,4.6C55.9,33.4,33.3,56,4.6,58.3L0,58.7
            V885l4.6,0.4c13.9,1.1,26.9,7.2,36.8,17.1c9.9,9.9,15.9,23,17,36.9l0.4,4.6H812l0.4-4.6c1.1-13.9,7.1-27.1,17.1-37
            c9.9-9.9,23.1-16,37-17.1l4.6-0.4V58.7L866.4,58.3z"
          />
        </clipPath>
        <filter
          id="board-blend"
          x="0"
          y="0"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
          primitiveUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            result="componentTransfer"
            x="0"
            y="0"
            width="100%"
            height="100%"
            floodColor="var(--dark-red)"
            floodOpacity="0.25"
          />
          {/* <feColorMatrix
            type="matrix"
            values="1 0 0 0 0
              1 0 0 0 0
              1 0 0 0 0
              0 0 0 1 0"
            in="SourceGraphic"
            result="colormatrix"
          />
          <feComponentTransfer in="colormatrix" result="componentTransfer">
            <feFuncR type="table" tableValues="0.58 1" />
            <feFuncG type="table" tableValues="0.07 1" />
            <feFuncB type="table" tableValues="0.04 1" />
            <feFuncA type="table" tableValues="0 1" />
          </feComponentTransfer> */}
          <feBlend
            mode="color"
            in="componentTransfer"
            in2="SourceGraphic"
            result="blend"
          />
        </filter>
        <filter
          id="hex-cover-violet"
          x="0"
          y="0"
          width="100%"
          height="100%"
          // x="7.04688"
          // y="6.06958"
          // width="166.342"
          // height="143.53"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="28.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1713_74715"
          />
        </filter>
        <filter
          id="purple-sepia"
          x="-10%"
          y="-10%"
          width="120%"
          height="120%"
          filterUnits="objectBoundingBox"
          primitiveUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feColorMatrix
            type="matrix"
            values=".33 .33 .33 0 0
                  .33 .33 .33 0 0
                  .33 .33 .33 0 0
                  0 0 0 1 0"
            in="SourceGraphic"
            result="colormatrix"
          />
          <feComponentTransfer in="colormatrix" result="componentTransfer">
            <feFuncR type="table" tableValues="0.22 0.46" />
            <feFuncG type="table" tableValues="0.12 0.23" />
            <feFuncB type="table" tableValues="0.37 0.68" />
            <feFuncA type="table" tableValues="0 1" />
          </feComponentTransfer>
          <feBlend
            mode="color"
            in="componentTransfer"
            in2="SourceGraphic"
            result="blend"
          />
        </filter>
        <filter
          id="cherry-icecream"
          x="0"
          y="0"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
          primitiveUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feColorMatrix
            type="matrix"
            values=".33 .33 .33 0 0
          .33 .33 .33 0 0
          .33 .33 .33 0 0
          0 0 0 1 0"
            in="SourceGraphic"
            result="colormatrix"
          />
          <feComponentTransfer in="colormatrix" result="componentTransfer">
            <feFuncR type="table" tableValues="0.84 1" />
            <feFuncG type="table" tableValues="0.05 0.94" />
            <feFuncB type="table" tableValues="0.37 0.61" />
            <feFuncA type="table" tableValues="0 1" />
          </feComponentTransfer>
          <feBlend
            mode="normal"
            in="componentTransfer"
            in2="SourceGraphic"
            result="blend"
          />
        </filter>
      </defs>
    </svg>
  );
}
